import React from 'react';

const Portfolio = () => {
    return(<>
     <section id="header" className="d-flex align-items-center">
        <div className="container-fluid">
            <div className="row">
                <div className="col-10 mx-auto">
                <div className="row">  
                    <div className="col-md-6 pt-lg-0 order-2 order-lg-1  d-flex flex-column justify-content-center">
                        <h3 className="design"> PROUD PARTNERS TO CATEGORY DEFINING COMPANIES. <strong className="bold_div"> <br />FROM THE START. </strong></h3>
                        
                        
                    </div>
               
                    </div>
                </div>
            </div>
        </div>
    </section>
     
    </>

    );
}
export default Portfolio;